import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingSCN, GetPendingSRA } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import ScnDetails from './ScnDetails';
import TableRow from './TableRow'

export default function ScnApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [OpenModal, setOpenModal] = useState(false);
    const [SingleData, setSingleData] = useState([]);



    const AllSRA = async () => {
        let result = await GetPendingSCN()

        console.log("object pending scn", result);

        if (result.status == true) {
            setData(result.queryresult.scndetails)

        }
    }

    const ReadMore = (id) => {

        let singleInfo = Data.filter((item, i) => {
          return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
      }

      const openApprove = (id)=>{
        onOpen()
        setId(id)
      }

    useEffect(() => {

        AllSRA()

    }, [isOpen]);


    return (
        <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

            <Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

            >
                <Table variant='simple' size='sm' overflowX="auto" >
                    <Thead>
                        <Tr>
                            <Th color="#fff">S/N</Th>
                            <Th color="#fff">Product name</Th>
                            <Th color="#fff">Price</Th>
                            <Th color="#fff">Qty Returned</Th>
                            <Th color="#fff">Returnee Dept</Th>
                            <Th color="#fff">Approve</Th>
                            <Th color="#fff">Read more</Th>


                        </Tr>
                    </Thead>
                    <Tbody>

                        {

                            Data?.map((item, i) => (
                                <TableRow
                                    key={i}
                                    sn={i + 1}
                                    type="scnApproval"
                                    productName={item.shelfid?.productname}
                                    price={item.price}
                                    qty={item.qtyreturned}
                                    dept={item.returneedepartment}
                                    status={item.status}
                                    onClick={() => ReadMore(item._id)}
                                    Approve={() => openApprove(item._id)}

                                />
                            ))
                        }


                    </Tbody>

                </Table>
            </TableContainer>
            <ScnDetails isOpen={OpenModal} onClose={()=>setOpenModal(!OpenModal)} singleData={SingleData} />
            {/* this is for the approval modal that receive the type of approval*/}
            <PendingIQA isOpen={isOpen} onClose={onClose} id={Id} state="ApproveScn"/>


        </Box>
    )
}
